import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import { API_URL, NODE_ENV } from "../../utils/constants";
import commonActions from "../../redux/common/actions";
import {
  Box,
  FormControl,
  Modal,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Checkbox,
  Grid,
  TextField,
  styled,
  Switch,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  TextareaAutosize,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  RadioGroup,
  Radio,
} from "@mui/material";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { cssProperties } from "../../utils/commonCssProperties";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import generateAdmitcardActions from "../../redux/admitcardgeneration/action";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { Controller, useForm } from "react-hook-form";
import modifyWordFileCard from "../../common/wordFilemodify";
import { IoClose } from "react-icons/io5";
import image from "../../assets/images/image.png";
import xlsx from "json-as-xlsx";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline } from "react-icons/io5";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import Barcode from "react-barcode";

export default function Index() {
  const dispatch = useDispatch();
  const { courseList } = useSelector((state) => state.masterReducer);
  const [courseid, setCourseId] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [courseName, setCourseName] = useState("");
  const now = new Date();
  const [intervalId, setIntervalId] = useState(null);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const socketRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [modifiedFileUrl, setModifiedFileUrl] = useState(null);
  const [preview, setPreview] = useState(null);
  const { coursecandidatelist } = useSelector((state) => state.masterReducer);
  const targetApplicantId = coursecandidatelist?.[0]?.applicantid;
  const barcodeRef = useRef(null);

  const filteredResults = [
    {
      address1: "CAMP AREA NEAR DURGA MATA TEMPLE DHANORA ROAD GADCHIROLI",
      admitcardurl: null,
      applicantid: "259600001",
      batch: "1",
      referenceid: "122",
      candidateid: "33629",
      candidatename: "SHIBIN",
      coursename: "MAH-MCA-CET-2025",
      disabilitytype: "N/A",
      dob: "2009-12-01",
      endtime: "17:12:00",
      examdate: "2025-03-18",
      filename_1: "33629_photo.jpeg_20241210_094757",
      filename_2: "33629_signature.jpeg_20241210_094757",
      filename_3: "Feedback-16th.pdf",
      fileurl_1:
        "https://storage.googleapis.com/mh-cet-registration/uploads/33629/profile/33629_photo.jpeg_20241210_094757",
      fileurl_2:
        "https://storage.googleapis.com/mh-cet-registration/uploads/33629/profile/33629_signature.jpeg_20241210_094757",
      fileurl_3:
        "https://storage.googleapis.com/mh-cet-registration/uploads/33629/profile/Feedback-16th.pdf",
      finalmarks: null,
      gateclosingtime: "20:12:00",
      gender: "Male",
      isadmitcardgenerated: "0",
      isdisability: "Yes",
      isextratime: "Yes",
      isscribe: "Yes",
      languagename: "English",
      pastatus: null,
      percentage: null,
      referenceid: "V70",
      reportingtime: "22:18:00",
      rollno: "MHCET-AAAA-001",
      scorecarddocs: null,
      scorecardstartdate: "2025-03-06",
      starttime: "11:12:00",
      templatedocs:
        "https://storage.googleapis.com/mh-cet-registration/uploads/MAH-MCA-CET-2025/admitcard/templatedocs_1742474615403_20.docx",
      venuename: "GALAXY INFORMATION TECHNOLOGY",
      filename: "GALAXY INFORMATION TECHNOLOGY",
      venueaddress: "GALAXY INFORMATION TECHNOLOGY",
      Tradename: "GALAXY INFORMATION TECHNOLOGY",
      Seatno: "1222",
      coursecode: "12ff",
      city: "Tirupur",
      category_name: "ddd",
      examduration: "2 hr",
      examtime: "2:20 am",
      Religion: "hindhu",
      Caste: "BC",
      category_name: "OBC",
    },
  ];

  const { Externalcourselist } = useSelector(
    (state) => state.generateAdmitcardReducer
  );
  const { Bulkadmitcardcount } = useSelector(
    (state) => state.generateAdmitcardReducer
  );
  const generatedcount = Bulkadmitcardcount?.filter(
    (c) => c?.admitcardurl && c?.admitcardurl?.length > 0
  )?.length;

  const [metadata, setMetaData] = useState(false);
  const [uploadfile, setUploadedFile] = useState(null);
  const [ipAddress, setIpAddress] = useState(null);
  const [ExternalCourseName, setExternalCourseName] = useState(null);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [candidatedata, setCandidatedata] = useState(null);
  const [open, setOpen] = useState({ open: false, type: null });
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const formatTime = (timeString) => {
    if (!timeString) return "";

    let [hh, mm] = timeString.split(":").map(Number);
    const period = hh >= 12 ? "PM" : "AM";

    hh = hh % 12 || 12;

    return `${hh}:${mm?.toString().padStart(2, "0")} ${period}`;
  };
  const isoDate = now.toISOString().split("T")[0];
  const isoTime = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const formatDate1 = (dateString) => {
    if (!dateString) return "";
    const [yyyy, mm, dd] = dateString.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };
  const toggleOpen = (type) => {
    setOpen({
      open: !open.open,
      type: type,
    });
  };
  let getDataInterval = (logid) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("listenexternaladmitcardstatus", { logid });
    }, 1000);
    return intervalId;
  };
  const handleDownloadZip = async () => {
    dispatch({
      type: generateAdmitcardActions.GET_EXTERNAL_ZIPFILE,
      payload: {
        externalcourseid: courseid,
      },
    });
    //   if (!Bulkadmitcardcount.length) return;

    //     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

    //   const zip = new JSZip();

    //   for (const candidate of Bulkadmitcardcount) {
    //     const fileUrl = candidate.admitcardurl;
    //     const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;
    //     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    //     try {
    //       const response = await fetch(fileUrl);
    //       if (!response.ok) {
    //         console.warn(`Skipping ${fileName}: HTTP ${response.status}`);
    //         continue;
    //       }

    //       const blob = await response.blob();
    //       zip.file(fileName, blob);
    //     } catch (error) {
    //       console.error(`Failed to fetch ${fileName}:`, error);
    //     }
    //   }

    //   zip.generateAsync({ type: 'blob' }).then((content) => {
    //     saveAs(content, 'AdmitCards.zip');
    //       dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });

    //   });
    //
  };
  useEffect(() => {
    socketRef.current = io(
      `${API_URL}`,
      NODE_ENV === "production" && {
        path: "/api/socket.io",
      }
    );
    return () => (socketRef.current = null);
  }, []);
  useEffect(() => {
    socketRef?.current?.on("listengetexternaladmitcardmessage", (message) => {
      if (message?.statusCode === 200) {
        let statustext = message?.data?.trim();
        if (
          statustext !=
          "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
        ) {
          if (statustext?.toLowerCase() !== "completed") {
            setStatusModalOpen({
              open: true,
              statustext:
                statustext?.trim() !== "" && statustext !== null
                  ? statustext
                  : statusModalopen.statustext,
            });
          } else {
            setStatusModalOpen({
              open: false,
              statustext:
                statustext?.toLowerCase() !== "completed"
                  ? ""
                  : statusModalopen.statustext,
            });
            dispatch({
              type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
              payload: {
                externalcourseid: courseid,
              },
            });
            clearInterval(intervalId);
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "success",
                show: true,
                message: "Admitcard Generated successfully",
              },
            });

            setTimeout(function () {
              dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "success",
                  show: false,
                  message: null,
                },
              });
            }, 2000);
          }
        } else {
          clearInterval(intervalId);
          dispatch({
            type: commonActions.SET_ALERT,
            payload: {
              status: "failed",
              show: true,
              message:
                statustext ==
                "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  ? "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  : "Failed",
            },
          });
          setTimeout(function () {
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "failed",
                show: false,
                message: null,
              },
            });
          }, 2000);
          setStatusModalOpen({
            open: false,
            statustext: "",
          });
          dispatch({
            type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
            payload: {
              externalcourseid: courseid,
            },
          });
        }
      }
    });

    return () => socketRef?.current?.off("listenmessage");
  }, [dispatch, intervalId, socketRef]);
  useEffect(() => {
    if (barcodeRef.current) {
      const svgElement = barcodeRef.current.querySelector("svg");

      if (svgElement) {
        const svgString = new XMLSerializer().serializeToString(svgElement);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        const svgBlob = new Blob([svgString], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const dataUrl = canvas.toDataURL("image/png");
          setBarcodeDataUrl(dataUrl);
          URL.revokeObjectURL(url);
        };

        img.src = url;
      }
    }
  }, [filteredResults]);

  const handleUploadTemplate = () => {
    dispatch({
      type: generateAdmitcardActions.GENERATE_EXTERNAL_ADMITCARD,
      payload: {
        externalcourseid: courseid,
        setOpen: setOpen,
        getDataInterval: getDataInterval,
        setIntervalId: setIntervalId,
        setStatusModalOpen: setStatusModalOpen,
        file: candidatedata,
        dispatch: dispatch,
      },
    });
  };
  const handlegenerate = () => {
    dispatch({
      type: generateAdmitcardActions.GENERATE_BULK_ADMITCARD,
      payload: {
        externalcourseid: courseid,
        getDataInterval: getDataInterval,
        setIntervalId: setIntervalId,
        setStatusModalOpen: setStatusModalOpen,
        dispatch: dispatch,
      },
    });
  };

  useEffect(() => {
    dispatch({
      type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
      payload: {
        externalcourseid: courseid,
      },
    });
  }, [courseid]);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [yyyy, mm, dd] = dateString.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  // const placeholders = [
  //   {
  //     originalText: "<name>",
  //     replaceText: /<name>/g,
  //     value: filteredResults?.[0]?.candidatename,
  //     Name: "Candidate’s Full Name",
  //   },
  //   {
  //     originalText: "<filename>",
  //     replaceText: /<filename>/g,
  //     value: filteredResults?.[0]?.filename,
  //     Name: "File name",
  //   },
  //   {
  //     originalText: "<Scribename>",
  //     replaceText: /<Scribename>/g,
  //     value: filteredResults?.[0]?.Scribename,
  //     Name: "Scribe Name",
  //   },
  //   {
  //     originalText: "<Tradename>",
  //     replaceText: /<Tradename>/g,
  //     value: filteredResults?.[0]?.Tradename,
  //     Name: "Trade Name",
  //   },
  //   {
  //     originalText: "<Seatno>",
  //     replaceText: /<Seatno>/g,
  //     value: filteredResults?.[0]?.Seatno,
  //     Name: "Seat Number",
  //   },
  //   {
  //     originalText: "<coursecode>",
  //     replaceText: /<coursecode>/g,
  //     value: filteredResults?.[0]?.coursecode,
  //     Name: "Coursecode",
  //   },
  //   {
  //     originalText: "<city>",
  //     replaceText: /<city>/g,
  //     value: filteredResults?.[0]?.city,
  //     Name: "city",
  //   },
  //   {
  //     originalText: "<batch>",
  //     replaceText: /<batch>/g,
  //     value: filteredResults?.[0]?.batch,
  //     Name: "batch",
  //   },
  //   {
  //     originalText: "<venuename>",
  //     replaceText: /<venuename>/g,
  //     value: filteredResults?.[0]?.venuename,
  //     Name: "venuename",
  //   },
  //   {
  //     originalText: "<rollno>",
  //     replaceText: /<rollno>/g,
  //     value: filteredResults?.[0]?.rollno,
  //     Name: "Roll Number",
  //   },
  //   {
  //     originalText: "<gender>",
  //     replaceText: /<gender>/g,
  //     value: filteredResults?.[0]?.gender,
  //     Name: "Gender",
  //   },
  //   {
  //     originalText: "<appno>",
  //     replaceText: /<appno>/g,
  //     value: filteredResults?.[0]?.applicantid,
  //     Name: "Application Number",
  //   },
  //   {
  //     originalText: "<examtime>",
  //     replaceText: /<examtime>/g,
  //     value: formatTime(filteredResults?.[0]?.examtime),
  //     Name: "Shift Time",
  //   },
  //   {
  //     originalText: "<religion>",
  //     replaceText: /<religion>/g,
  //     value: formatTime(filteredResults?.[0]?.religion),
  //     Name: "religion",
  //   },
  //   {
  //     originalText: "<Caste>",
  //     replaceText: /<Caste>/g,
  //     value: formatTime(filteredResults?.[0]?.Caste),
  //     Name: "Caste",
  //   },

  //   {
  //     originalText: "<categoryname>",
  //     replaceText: /<categoryname>/g,
  //     value: formatTime(filteredResults?.[0]?.categoryname),
  //     Name: "categoryname",
  //   },
  //   {
  //     originalText: "<lang>",
  //     replaceText: /<lang>/g,
  //     value: filteredResults?.[0]?.languagename,
  //     Name: "Question Paper Language",
  //   },
  //   {
  //     originalText: "<examdate>",
  //     replaceText: /<examdate>/g,
  //     value: formatDate1(filteredResults?.[0]?.examdate),
  //     Name: "Date of Examination",
  //   },
  //   {
  //     originalText: "<dob>",
  //     replaceText: /<dob>/g,
  //     value: formatDate1(filteredResults?.[0]?.dob),
  //     Name: "Date of Birth",
  //   },
  //   {
  //     originalText: "<disability>",
  //     replaceText: /<disability>/g,
  //     value: filteredResults?.[0]?.isdisability == 0 ? "Yes" : "No",
  //     Name: "Person with Disability (PWD)",
  //   },
  //   {
  //     originalText: "<disabilitytype>",
  //     replaceText: /<disabilitytype>/g,
  //     value: filteredResults?.[0]?.disabilitytype,
  //     Name: "Disability Type",
  //   },
  //   {
  //     originalText: "<isextratime>",
  //     replaceText: /<isextratime>/g,
  //     value: filteredResults?.[0]?.isextratime == 0 ? "Yes" : "No",
  //     Name: "Extra Time Required",
  //   },
  //   {
  //     originalText: "<ipaddress>",
  //     replaceText: /<ipaddress>/g,
  //     value: ipAddress,
  //     Name: "IP Address",
  //   },
  //   {
  //     originalText: "<date>",
  //     replaceText: /<date>/g,
  //     value: formatDate1(isoDate),
  //     Name: "Date of download of Admit Card",
  //   },
  //   {
  //     originalText: "<time>",
  //     replaceText: /<time>/g,
  //     value: formatTime(isoTime),
  //     Name: "Time of download of Admit Card",
  //   },
  //   {
  //     originalText: "<coursename>",
  //     replaceText: /<coursename>/g,
  //     value: filteredResults?.[0]?.coursename,
  //     Name: "Course Name",
  //   },
  //   {
  //     originalText: "<scribe>",
  //     replaceText: /<scribe>/g,
  //     value: filteredResults?.[0]?.isscribe == 0 ? "Yes" : "No",
  //     Name: "Scribe Required",
  //   },
  //   {
  //     originalText: "<venuecode>",
  //     replaceText: /<venuecode>/g,
  //     value: filteredResults?.[0]?.referenceid,
  //     Name: "Venue Code",
  //   },
  //   {
  //     originalText: "<venueaddress>",
  //     replaceText: /<venueaddress>/g,
  //     value: filteredResults?.[0]?.address1,
  //     Name: "Venue Address",
  //   },
  //   {
  //     originalText: "<reptime>",
  //     replaceText: /<reptime>/g,
  //     value: formatTime(filteredResults?.[0]?.reportingtime),
  //     Name: "Reporting Time at the CET Examination Centre",
  //   },
  //   {
  //     originalText: "<examduration>",
  //     replaceText: /<examduration>/g,
  //     value: formatTime(filteredResults?.[0]?.examduration),
  //     Name: "Exam duration",
  //   },
  //   {
  //     originalText: "<closuretime>",
  //     replaceText: /<closuretime>/g,
  //     value: formatTime(filteredResults?.[0]?.endtime),
  //     Name: "Gate Closure Time",
  //   },
  //   // { originalText: "<barcode>", replaceText: /<barcode>/g, value:<Barcode value="barcode-example" />, Name: "Barcode" }
  // ];
  const placeholders = [
    {
      originalText: "<name>",
      replaceText: /<name>/g,
      value: filteredResults?.[0]?.candidatename,
      Name: "Candidate’s Full Name",
    },
    {
      originalText: "<rollno>",
      replaceText: /<rollno>/g,
      value: filteredResults?.[0]?.rollno,
      Name: "Roll Number/User Name",
    },
    {
      originalText: "<gender>",
      replaceText: /<gender>/g,
      value: filteredResults?.[0]?.gender,
      Name: "Gender",
    },
    {
      originalText: "<appno>",
      replaceText: /<appno>/g,
      value: filteredResults?.[0]?.applicantid,
      Name: "Application Number",
    },
    {
      originalText: "<examtime>",
      replaceText: /<examtime>/g,
      value: filteredResults?.[0]?.starttime,
      Name: "Reporting Time at the CET examination Centre",
    },
    {
      originalText: "<reptime>",
      replaceText: /<reptime>/g,
      value: filteredResults?.[0]?.reportingtime,
      Name: "Roll Number/User Name",
    },
    {
      originalText: "<closuretime>",
      replaceText: /<closuretime>/g,
      value: filteredResults?.[0]?.gateclosingtime,
      Name: "Gate Closure Time",
    },
    {
      originalText: "<lang>",
      replaceText: /<lang>/g,
      value: filteredResults?.[0]?.languagename,
      Name: "Question Paper Language",
    },
    {
      originalText: "<examdate>",
      replaceText: /<examdate>/g,
      value: filteredResults?.[0]?.examdate,
      Name: "Date of CET Examination",
    },
    {
      originalText: "<category_name>",
      replaceText: /<category_name>/g,
      value: filteredResults?.[0]?.category_name,
      Name: "category_name",
    },
    {
      originalText: "<city>",
      replaceText: /<city>/g,
      value: filteredResults?.[0]?.city,
      Name: "city",
    },
    {
      originalText: "<Caste>",
      replaceText: /<Caste>/g,
      value: filteredResults?.[0]?.Caste,
      Name: "Caste",
    },
    {
      originalText: "<dob>",
      replaceText: /<dob>/g,
      value: filteredResults?.[0]?.dob,
      Name: "DOB/Password",
    },
    {
      originalText: "<disability>",
      replaceText: /<disability>/g,
      value: filteredResults?.[0]?.isdisability,
      Name: "Person with Disability (PWD)",
    },
    {
      originalText: "<coursecode>",
      replaceText: /<coursecode>/g,
      value: filteredResults?.[0]?.coursecode,
      Name: "coursecode",
    },
    {
      originalText: "<disabilitytype>",
      replaceText: /<disabilitytype>/g,
      value: filteredResults?.[0]?.disabilitytype,
      Name: "Disability Type",
    },
    {
      originalText: "<isscribe>",
      replaceText: /<isscribe>/g,
      value: filteredResults?.[0]?.isscribe,
      Name: "isscribe",
    },
    {
      originalText: "<category_name>",
      replaceText: /<category_name>/g,
      value: filteredResults?.[0]?.category_name,
      Name: "category Name",
    },
    {
      originalText: "<date>",
      replaceText: /<date>/g,
      value: formatDate(isoDate),
      Name: "Date",
    },
    {
      originalText: "<time>",
      replaceText: /<time>/g,
      value: formatTime(isoTime),
      Name: "Time",
    },
    {
      originalText: "<coursename>",
      replaceText: /<coursename>/g,
      value: filteredResults?.[0]?.coursename,
      Name: "Course name",
    },
    {
      originalText: "<venuecode>",
      replaceText: /<venuecode>/g,
      value: filteredResults?.[0]?.referenceid,
      Name: "Venue Code",
    },
    {
      originalText: "<venuename>",
      replaceText: /<venuename>/g,
      value: filteredResults?.[0]?.venuename,
      Name: "Venue Name",
    },
    {
      originalText: "<batch>",
      replaceText: /<batch>/g,
      value: filteredResults?.[0]?.batch,
      Name: "Batch",
    },
    {
      originalText: "<venueaddress>",
      replaceText: /<venueaddress>/g,
      value: filteredResults?.[0]?.venueaddress,
      Name: "Venue Address",
    },
    {
      originalText: "<religion>",
      replaceText: /<religion>/g,
      value: filteredResults?.[0]?.Religion,
      Name: "Religion",
    },
    {
      originalText: "<examduration>",
      replaceText: /<examduration>/g,
      value: filteredResults?.[0]?.examduration,
      Name: "Examduration",
    },
    // { originalText: "<barcode>", replaceText: /<barcode>/g, value:<Barcode value="barcode-example" />, Name: "Barcode" }
  ];
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: generateAdmitcardActions.GET_EXTERNAL_COURSE });
  }, []);
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showIframe, setShowIframe] = useState(false);

  const handleChangeCourse = (e) => {
    const selectedCourseId = e.target.value;
    const selectedCourse = Externalcourselist.find(
      (course) => course.externalcourseid === selectedCourseId
    );
    dispatch({ type: generateAdmitcardActions.GET_EXTERNAL_COURSE });
    dispatch({
      type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
      payload: {
        externalcourseid: selectedCourseId,
      },
    });
    setCourseId(selectedCourseId);
    setExternalCourseName(selectedCourse ? selectedCourse.coursename : "");
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCourseName("");
  };

  const handleFileUpload = (e) => {
    setMessage("");
    const uploadedFile = e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setFile(uploadedFile);
    setFileName(uploadedFile ? uploadedFile.name : "");
  };
  useEffect(() => {
    if (courseid) {
      const selectedCourse = Externalcourselist.find(
        (course) => course.externalcourseid === courseid
      );

      if (selectedCourse) {
        setUploadedFile(selectedCourse?.admitcardtemplateurl);
        setFile(selectedCourse?.admitcardtemplateurl);
        setFileName(selectedCourse.admitcardtemplateurl?.split("/")?.pop());
      }
    }
  }, [courseid]);
  const handleSubmitCourse = () => {
    setCourseName(courseName);
    dispatch({
      type: generateAdmitcardActions.ADD_EXTERNAL_COURSE,
      payload: {
        coursename: courseName,
        isadmitcardpublished: `1`,
        userid: backofficeTokenDetails?.id,
        dispatch: dispatch,
      },
    });
    handleCloseModal();
  };

  const handleAddCourse = () => {
    dispatch({
      type: generateAdmitcardActions.INSERT_EXTERNAL_COURSE,
      payload: {
        coursename: ExternalCourseName,
        admitcardtemplateurl: uploadfile,
        isadmitcardpublished: `1`,
        userid: backofficeTokenDetails?.id,
        externalcourseid: courseid,
      },
    });
    dispatch({
      type: generateAdmitcardActions.GET_BULK_ADMITCARD_COUNT,
      payload: {
        externalcourseid: courseid,
      },
    });
    dispatch({ type: generateAdmitcardActions.GET_EXTERNAL_COURSE });
  };
  // let data = [
  //   {
  //     sheet: "Admitcard Generation Template",
  //     columns: [
  //       { label: "S.No" },
  //       { label: "File Name" },
  //       { label: "RollNumber" },
  //       { label: "Application No." },
  //       { label: "Candidate_Name" },
  //       { label: "Gender" },
  //       { label: "DOB" },
  //       { label: "Post/Course Code" },
  //       { label: "Post/Course Name" },
  //       { label: "Apply City" },
  //       { label: "Final City" },
  //       { label: "Centre Code" },
  //       { label: "Centre Name" },
  //       { label: "Centre Address" },
  //       { label: "Shift" },
  //       { label: "Reporting Time" },
  //       { label: "Gate closer Time" },
  //       { label: "Shift Time" },
  //       { label: "photo" },
  //       { label: "signature" },
  //       { label: "Religion" },
  //       { label: "Caste" },
  //       { label: "category_name" },
  //       { label: "PWD STATUS" },
  //       { label: "PWD TYPE" },
  //       { label: "Scribe Allowed" },
  //       { label: "Scribe Name" },
  //       { label: "Trade Name" },
  //       { label: "Exam Date" },
  //       { label: "Exam Duration" },
  //       { label: "Seat Number" },
  //       { label: "Exam Language" },
  //     ],

  //     content: [],
  //   },
  // ];
  let data = [
    {
      sheet: "Admitcard Generation Template",
      columns: [
        { label: "S.No", value: "S_No" },
        { label: "File Name", value: "File Name" },
        { label: "RollNumber", value: "RollNumber" },
        { label: "Application No.", value: "Application_no" },
        { label: "Candidate_Name", value: "Candidate_Name" },
        { label: "Gender", value: "Gender" },
        { label: "DOB", value: "DOB" },
        { label: "Post/Course Code", value: "Post/Course Code" },
        { label: "Post/Course Name", value: "Post/Course Name" },
        { label: "Apply City", value: "Apply City" },
        { label: "Final City", value: "Final City" },
        { label: "Centre Code", value: "Centre Code" },
        { label: "Centre Name", value: "Centre Name" },
        { label: "Centre Address", value: "Centre Address" },
        { label: "Shift", value: "Shift" },
        { label: "Reporting Time", value: "Reporting Time" },
        { label: "Gate closer Time", value: "Gate closer Time" },
        { label: "Shift Time", value: "Shift Time" },
        { label: "photo", value: "photo" },
        { label: "signature", value: "signature" },
        { label: "Religion", value: "Religion" },
        { label: "Caste", value: "Caste" },
        { label: "category_name", value: "category_name" },
        { label: "PWD STATUS", value: "PWD STATUS" },
        { label: "PWD TYPE", value: "PWD TYPE" },
        { label: "Scribe Allowed", value: "Scribe Allowed" },
        { label: "Scribe Name", value: "Scribe Name" },
        { label: "Trade Name", value: "Trade Name" },
        { label: "Exam Date", value: "Exam Date" },
        { label: "Exam Duration", value: "Exam Duration" },
        { label: "Seat Number", value: "Seat Number" },
        { label: "Exam Language", value: "Exam Language" },
      ],
      content: [
        {
          S_No: "1",
          "File Name": "MHCET-2002",
          RollNumber: "MHCET2001",
          Application_no: "MH2024001",
          Candidate_Name: "Rahul Sharma",
          Gender: "Male",
          DOB: "2001-05-10",
          "Post/Course Code": "PCC101",
          "Post/Course Name": "Engineering",
          "Apply City": "Mumbai",
          "Final City": "Nagpur",
          "Centre Code": "CT001",
          "Centre Name": "Govt Exam Centre",
          "Centre Address": "Sector 4, Near City Mall, Nagpur",
          Shift: "Morning",
          "Reporting Time": "08:00 AM",
          "Gate closer Time": "08:30 AM",
          "Shift Time": "09:00 AM - 12:00 PM",
          photo:
            "https://storage.googleapis.com/mh-cet-registration/uploads/33629/profile/33629_photo.jpeg_20241210_094757",
          signature:
            "https://storage.googleapis.com/mh-cet-registration/uploads/33629/profile/33629_signature.jpeg_20241210_094757",
          Religion: "Hindu",
          Caste: "OBC",
          category_name: "General",
          "PWD STATUS": "Yes",
          "PWD TYPE": "Vision impartity",
          "Scribe Allowed": "No",
          "Scribe Name": "name",
          "Trade Name": "Mechanical",
          "Exam Date": "2025-06-01",
          "Exam Duration": "3 hours",
          "Seat Number": "A12",
          "Exam Language": "English",
        },
      ],
    },
  ];

  let callback = function (sheet) {};
  let settings = {
    fileName: "Admitcard Generation template",
    extraLength: 3,
    writeMode: "writeFile",
    writeOptions: {},
    RTL: false,
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setCandidatedata(file);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
  };
  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        {/* <FormControl sx={{ minWidth: 200 }}>
          <Select
            size="small"
            value={courseid}
            onChange={handleChangeCourse}
            displayEmpty
            sx={{ width: "100%" }}
          >
            <MenuItem value={0}>Courses</MenuItem>
            {Externalcourselist?.map((course, i) => (
              <MenuItem key={i} value={course.externalcourseid}>
                {course.coursename}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <FormControl sx={{ minWidth: 200 }}>
          <Select
            size="small"
            value={courseid}
            onChange={handleChangeCourse}
            displayEmpty
            sx={{ width: "100%" }}
          >
            <MenuItem value={0}>Courses</MenuItem>
            {(Array.isArray(Externalcourselist) ? [...Externalcourselist] : [])
              .sort((a, b) => a.coursename.localeCompare(b.coursename))
              .map((course, i) => (
                <MenuItem key={i} value={course.externalcourseid}>
                  {course.coursename}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          onClick={handleOpenModal}
          sx={{
            color: "black",
            borderColor: "#A3A3A3",
            minWidth: 50,
            height: 40,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaPlus />
        </Button>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
            position: "relative",
          }}
        >
          <TextField
            sx={{ width: "300px" }}
            label={
              <span>
                Upload AdmitCard Template
                <span className="error" style={{ color: "red" }}>
                  {" "}
                  *
                </span>
              </span>
            }
            type="text"
            value={fileName || "No file chosen"}
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <label
                  htmlFor="file-input"
                  style={{
                    cursor: "pointer",
                    color: "#1976d2",
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                  }}
                >
                  Choose File
                </label>
              ),
            }}
            error={!!errors.uploadfile}
            helperText={errors.uploadfile?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
          <input
            type="file"
            accept=".doc, .docx"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            id="file-input"
          />
          <Button
            variant="contained"
            size="small"
            style={{
              marginLeft: "8px",
              height: "40px",
            }}
            onClick={() => {
              modifyWordFileCard({
                uploadfile,
                dispatch,
                ipAddress,
                filteredResults,
                setModifiedFileUrl,
                setPreview,
                setMessage,
                placeholders,
                setIsDialogOpen,
                setMetaData,
                setShowIframe,
                barcodeDataUrl,
                // candidateName: candidate?.candidatename,
              });
            }}
            disabled={!fileName || coursecandidatelist?.length == 0}
          >
            Preview
          </Button>
        </div>
        <MauvelousPrimaryButton
          title="View Meta Data"
          handleClick={() => {
            setMetaData(true);
            setIsDialogOpen(true);
            setShowIframe(false);
          }}
        />
        <MauvelousPrimaryButton
          title="Publish Admitcard"
          disabled={!fileName || coursecandidatelist?.length == 0}
          handleClick={handleAddCourse}
        />
      </Box>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="h6">Add New Course</Typography>
          <TextField
            label="Course Name"
            variant="outlined"
            fullWidth
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <MauvelousPrimaryButton
              title="Cancel"
              handleClick={() => {
                handleCloseModal();
              }}
            />

            <MauvelousPrimaryButton
              title="Save"
              handleClick={() => {
                handleSubmitCourse();
              }}
            />
          </Box>
        </Box>
      </Modal>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          marginTop: "10px",
        }}
      >
        {isDialogOpen && (
          <Dialog open={isDialogOpen} maxWidth="xl" fullWidth>
            <DialogTitle>
              <Box
                mt={2}
                sx={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {showIframe && (
                  <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
                    Preview AdmitCard
                  </Typography>
                )}
                {metadata && (
                  <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
                    MetaData
                  </Typography>
                )}

                <Box
                  sx={{
                    position: "absolute",
                    right: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <button
                    onClick={() => setIsDialogOpen(false)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "40px",
                      height: "40px",
                      cursor: "pointer",
                      background: "none",
                      borderRadius: "50%",
                      border: "1px solid #ccc",
                      cursor: "pointer",
                    }}
                  >
                    <IoClose size={16} />
                  </button>
                </Box>
              </Box>
            </DialogTitle>

            <DialogContent>
              <Box>
                {showIframe && (
                  <iframe
                    src={preview}
                    width="100%"
                    height="600px"
                    style={{ border: "none", marginTop: "10px" }}
                  ></iframe>
                )}
                {metadata && (
                  <div className="flex justify-center mt-6">
                    <TableContainer
                      component={Paper}
                      sx={{ maxWidth: 800, margin: "auto", marginTop: 4 }}
                    >
                      <Table sx={{ border: "2px solid black" }}>
                        <TableHead>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                border: "2px solid black",
                              }}
                            >
                              Field
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                border: "2px solid black",
                              }}
                            >
                              Metadata
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {placeholders.map((replacement, index) => (
                            <TableRow
                              key={index}
                              sx={{ borderBottom: "2px solid black" }}
                            >
                              <TableCell sx={{ border: "2px solid black" }}>
                                {replacement?.originalText || "N/A"}
                              </TableCell>
                              <TableCell sx={{ border: "2px solid black" }}>
                                {replacement?.Name || "N/A"}
                              </TableCell>
                            </TableRow>
                          ))}

                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"<image>"}
                            </TableCell>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"Photo"}
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"<signature>"}
                            </TableCell>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"Signature"}
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"<barcode>"}
                            </TableCell>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"Barcode"}
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell
                              sx={{ border: "2px solid black", color: "red" }}
                            >
                              {"ONLY THESE FONT TO USED"}
                            </TableCell>
                            <TableCell
                              sx={{ border: "2px solid black", color: "red" }}
                            >
                              <ul style={{ paddingLeft: "16px", margin: 0 }}>
                                {[
                                  "Arial",
                                  "Arial Black",
                                  "Bahnschrift",
                                  "Bahnschrift Condensed",
                                  "Bahnschrift Light",
                                  "Bahnschrift Light Condensed",
                                  "Bahnschrift Light SemiCondensed",
                                  "Bahnschrift SemiBold",
                                  "Bahnschrift SemiBold Condensed",
                                  "Bahnschrift SemiBold SemiCondensed",
                                  "Bahnschrift SemiCondensed",
                                  "Bahnschrift SemiLight",
                                  "Bahnschrift SemiLight Condensed",
                                  "Bahnschrift SemiLight SemiCondensed",
                                  "Calibri",
                                  "Calibri Light",
                                  "Cambria",
                                  "Candara",
                                  "Ebrima",
                                  "Franklin Gothic Medium",
                                  "Gabriola",
                                  "Gadugi",
                                  "Georgia",
                                  "HoloLens MDL2 Assets",
                                  "Impact",
                                  "Ink Free",
                                  "Javanese Text",
                                  "Leelawadee UI",
                                  "Leelawadee UI Semilight",
                                  "Lucida Console",
                                  "Lucida Sans Unicode",
                                  "Malgun Gothic",
                                  "Microsoft Himalaya",
                                  "Microsoft JhengHei",
                                  "Microsoft JhengHei Light",
                                  "Microsoft JhengHei UI",
                                  "Microsoft JhengHei UI Light",
                                  "Microsoft New Tai Lue",
                                  "Microsoft PhagsPa",
                                  "Microsoft Sans Serif",
                                  "Microsoft Tai Le",
                                  "Microsoft YaHei",
                                  "Microsoft YaHei Light",
                                  "Microsoft YaHei UI",
                                  "Microsoft YaHei UI Light",
                                  "Microsoft Yi Baiti",
                                  "MingLiU-ExtB",
                                  "MingLiU_HKSCS-ExtB",
                                  "Mongolian Baiti",
                                  "MS Gothic",
                                  "MS PGothic",
                                  "MS UI Gothic",
                                  "MV Boli",
                                  "Myanmar Text",
                                  "Nirmala UI",
                                  "Nirmala UI Semilight",
                                  "NSimSun",
                                  "Palatino Linotype",
                                  "PMingLiU-ExtB",
                                  "Segoe MDL2 Assets",
                                  "Segoe Print",
                                  "Segoe Script",
                                  "Segoe UI",
                                  "Segoe UI Black",
                                  "Segoe UI Emoji",
                                  "Segoe UI Historic",
                                  "Segoe UI Light",
                                  "Segoe UI Semibold",
                                  "Segoe UI Semilight",
                                  "Segoe UI Symbol",
                                  "SimSun",
                                  "SimSun-ExtB",
                                  "Sitka Banner",
                                  "Sitka Display",
                                  "Sitka Heading",
                                  "Sitka Small",
                                  "Sitka Subheading",
                                  "Sitka Text",
                                  "Sylfaen",
                                  "Tahoma",
                                  "Times New Roman",
                                  "Trebuchet MS",
                                  "Verdana",
                                  "Yu Gothic",
                                  "Yu Gothic Light",
                                  "Yu Gothic Medium",
                                  "Yu Gothic UI",
                                  "Yu Gothic UI Light",
                                  "Yu Gothic UI Semibold",
                                  "Yu Gothic UI Semilight",
                                ].map((font, index) => (
                                  <li key={index} style={{ fontFamily: font }}>
                                    {font}
                                  </li>
                                ))}
                              </ul>
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"For Image"}
                            </TableCell>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {
                                "Need to draw a Text box and inside that meta data to be updated"
                              }
                              <img src={image} />
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {"For Barcode"}
                            </TableCell>
                            <TableCell sx={{ border: "2px solid black" }}>
                              {
                                "Need to draw a Text box and inside that meta data to be updated"
                              }
                              <img src={image} />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                )}
              </Box>
            </DialogContent>
          </Dialog>
        )}
      </Box>
      {/* <Box
        mt={2}
        justifyContent="start"
        alignItems="center"
        display="flex"
        gap={1}
      >
        <MauvelousPrimaryButton
          handleClick={() => {
            toggleOpen("candidate");
          }}
          title="Upload Candidate Data"
          disabled={courseid==0 ||courseid==null }
        />

        <MauvelousPrimaryButton
          title="Download Candidate Template"
          handleClick={() => xlsx(data, settings, callback)}
        />
        <Button
          variant="contained"
          size="small"
          style={{
            marginLeft: "8px",
            height: "40px",
          }}
          onClick={handlegenerate}
          disabled={!Bulkadmitcardcount?.length || uploadfile == null}
        >
          Generate Admitcard
        </Button>
                <MauvelousPrimaryButton
          handleClick={handleDownloadZip}
          disabled={ Bulkadmitcardcount?.[0]?.admitcardurl ==null}
          title=" Download Admit Cards ZIP"
        ></MauvelousPrimaryButton>
      </Box> */}
      <Box
        mt={2}
        display="flex"
        flexWrap="wrap"
        gap={1}
        justifyContent={{ xs: "center", sm: "flex-start" }}
        alignItems="center"
      >
        <MauvelousPrimaryButton
          handleClick={() => toggleOpen("candidate")}
          title="Upload Candidate Data"
          disabled={courseid === 0 || courseid == null || fileName ==null}
        />

        <MauvelousPrimaryButton
          title="Download Candidate Template"
          handleClick={() => xlsx(data, settings, callback)}
        />

        <Button
          variant="contained"
          size="small"
          sx={{
            ml: { xs: 0, sm: 1 },
            height: "40px",
            mt: { xs: 1, sm: 0 },
          }}
          onClick={handlegenerate}
          disabled={Bulkadmitcardcount?.length==0 || uploadfile == null  || fileName ==null}
        >
          Generate Admitcard
        </Button>

        <MauvelousPrimaryButton
          handleClick={handleDownloadZip}
          disabled={Bulkadmitcardcount?.[0]?.admitcardurl == null}
          title="Download Admit Cards ZIP"
        />
      </Box>
      <Modal
        open={open.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {candidatedata ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{candidatedata?.name}</Box>
              <Box
                onClick={() => setCandidatedata(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={() => {
                toggleOpen();
                setCandidatedata(null);
              }}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading}
              handleClick={
                // open.type === "candidate"
                //   ? handleUploadCandidateData
                //   :
                handleUploadTemplate
              }
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            height: 200,
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
      <div ref={barcodeRef} style={{ display: "none" }}>
        <Barcode
          value={filteredResults?.[0]?.rollno}
          height={150}
          width={3}
          displayValue={true}
        />
      </div>
      {courseid > 0 && (
        <>
          <TableContainer>
            <Table style={{ marginTop: "3px" }}>
              <TableBody>
                <TableRow>
                  <TableCell style={{ border: "1px solid black" }}>
                    Total candidates for this course
                  </TableCell>
                  <TableCell style={{ border: "1px solid black" }}>
                    {Bulkadmitcardcount?.length
                      ? Bulkadmitcardcount?.length
                      : 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid black" }}>
                    Admit cards already generated
                  </TableCell>
                  <TableCell style={{ border: "1px solid black" }}>
                    {generatedcount ? generatedcount : 0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid black" }}>
                    Yet to generate admit cards
                  </TableCell>
                  <TableCell style={{ border: "1px solid black" }}>
                    {" "}
                    {Bulkadmitcardcount?.length - generatedcount
                      ? Bulkadmitcardcount?.length - generatedcount
                      : 0}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
}
